import React from 'react'
import { useField } from 'formik'
import NumberFormat from 'react-number-format'

function NeoOnlyNumber({
  value,
  placeholder,
  maxLength = '',
  className,
  onChange,
  disabled,
  tabIndex="",
  ...props
}) {
  const [field] = useField(props)
  return (
    <NumberFormat
      allowLeadingZeros={true}
      maxLength={maxLength}
      placeholder={placeholder}
      allowNegative={false}
      className={className}
      displayType={'input'}
      thousandSeparator={false}
      isNumericString
      onValueChange={onChange}
      disabled={disabled}
      tabIndex={tabIndex}
      {...field}
    />
  )
}

export default React.memo(NeoOnlyNumber)
